import React from "react";
import { DatePicker as AntDatePicker } from "antd";
import dayjs from "dayjs";

interface datePickerProps {
  disabled: boolean;
  inputType: string;
  name?: string;
  errorMessage?: string | undefined | string[];
  iserror?: boolean;
  value?: string | number;
  label?: string;
  inputRegex?: string;
  maxDate?: string;
  minDate?: string; // add this
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
}

export const DatePicker = ({
  disabled,
  label,
  iserror,
  name,
  value,
  maxDate,
  minDate, // add this
  onChange,
  onBlur,
  errorMessage,
}: datePickerProps) => {
  return (
    <div
      className="input-group"
      style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}
    >
      <div className="input-wrapper-label">
        <label className="input-label">
          <p>{label}</p>
        </label>
      </div>

      <div className="input-wrapper-textbox">
        <AntDatePicker
          className="input-textbox" // ✅ KEEP YOUR CSS
          style={{
            width: "100%",
            border: iserror ? "1.5px solid red" : undefined,
          }}
          placeholder="dd/mm/yy"
          format="DD MMM YYYY" // 🔥 12 Mar 2026 (UI format)
          value={value ? dayjs(value as string) : null}
          disabled={disabled}
          onChange={(date) => {
            if (!onChange) return;

            onChange({
              target: {
                name,
                value: date ? date.format("YYYY-MM-DD") : "", // backend format
              },
            });
          }}
          onBlur={onBlur}
          disabledDate={(current) => {
            if (!current) return false;

            if (minDate && current < dayjs(minDate)) return true;
            if (maxDate && current > dayjs(maxDate)) return true;

            return false;
          }}
        />

        {iserror && <div className="input-error">{errorMessage}</div>}
      </div>
    </div>
  );
};
